import React from 'react';
import { Text } from '@tribeplatform/react-ui-kit/Text';
import { MarkdownBlock } from '../Markdown/Block.js';
export const TextBlock = ({ value, size, align, truncate, format, }) => {
    return (React.createElement(Text, { size: size, align: align, truncate: truncate }, format === 'markdown' ? React.createElement(MarkdownBlock, { text: value }) : value));
};
//# sourceMappingURL=Block.js.map